import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Observable, catchError, EMPTY } from 'rxjs';
import { ApiService } from '../services/api.service';
import { NavigationService } from '../services/navigation.service';

export const apiIntegrationDetailResolver: ResolveFn<Observable<any>> = (
  route: ActivatedRouteSnapshot
) => {
  const slug: string = route.params['slug'];
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  return apiService.fetchApiIntegrationDetails(slug).pipe(
    catchError((error) => {
      navigationService.handleResolverError(error);
      return EMPTY;
    })
  );
};
